import React, { useContext } from "react";
import { Grid, Paper, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { userRegisterContext } from "../../UserRegisterPage";

export default function MailNotificationField() {
  const { mailNotification, setMailNotification } = useContext(userRegisterContext);

  const handleChangeMailNotification = (e) => {
    setMailNotification(Number(e.target.value));
  };

  return (
    <Paper elevation={0}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
      >
        <Grid
          item
          xs={4}
          sm={2.5}
          sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
        >
          新着マッチング
        </Grid>
        <Grid
          item
          xs={8}
          sm={9.5}
          sx={{ my: "20px", fontSize: 16, pl: "15px" }}
        >
          <RadioGroup value={mailNotification} row onChange={handleChangeMailNotification}>
            <FormControlLabel
              value={1}
              label={<Typography fontSize={16}>通知する</Typography>}
              control={
                <Radio
                  size="small"
                  sx={{ "&.Mui-checked": { color: "#28345E" } }}
                />
              }
            />
            <FormControlLabel
              value={0}
              label={<Typography fontSize={16}>通知しない</Typography>}
              control={
                <Radio
                  size="small"
                  sx={{ "&.Mui-checked": { color: "#28345E" } }}
                />
              }
            />
          </RadioGroup>
        </Grid>
      </Grid>
    </Paper>
  );
}